import React from 'react'
// import BarChart from '../../charts/BarChart'

const Chart = () => {
  return (
    <div>
      {/* <BarChart/> */}
    </div>
  )
}

export default Chart
